import AssetLogo from "../asset-logo";

export default function LeagueLogo({ leagueId, size = 40, className = '' }: { leagueId: number, size?: number, className?: string }) {
    return (
        <AssetLogo
            id={leagueId}
            folder="leagues"
            alt="league logo"
            size={size}
            className={className}
        />
    );
}